import PropTypes from 'prop-types';
import React from 'react';
import { Record } from 'immutable';
import Col from 'react-bootstrap/lib/Col';

import { translate as t } from '../../lib/I18n';
import FeatureFlagStore from '../../stores/FeatureFlagStore';
import connectToStores from '../../helpers/connectToStores';
import SmartcardRegistration from '../../records/customer/SmartcardRegistration';

import PhoneNumber from '../payment/PhoneNumber';
import AgeCheckbox from './marketingPrefs/AgeCheckbox';
import SignupTAndCs, { PrivacyPolicyLink } from './SignupTAndCs';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import PrefsTable from './marketingPrefs/PrefsTable';
import FormError from '../form/Error';


const _getStateFromStores = () => {
    const enableEmailMarketing = FeatureFlagStore.get('enableEmailMarketing');
    const enableSmsMarketing = FeatureFlagStore.get('enableSmsMarketing');
    const enablePrefCentreUnder16Warning = FeatureFlagStore.get('enablePrefCentreUnder16Warning');
    return {
        enableEmailMarketing,
        enableSmsMarketing,
        enablePrefCentreUnder16Warning
    };
};

export class CustomerSignupOptions extends React.PureComponent {
    static propTypes = {
        form: PropTypes.instanceOf(Record).isRequired,
        onChange: PropTypes.func.isRequired,
        onAgeToggle: PropTypes.func.isRequired,
        smartcard: PropTypes.instanceOf(SmartcardRegistration),
        visited: PropTypes.bool,
        enableEmailMarketing: PropTypes.bool,
        enableSmsMarketing: PropTypes.bool,
        enablePrefCentreUnder16Warning: PropTypes.bool,
        includePhoneField: PropTypes.bool,
        noTandC: PropTypes.bool,
        noOptDescription: PropTypes.bool,
        noPreferenceNotice: PropTypes.bool
    };

    static defaultProps = {
        smartcard: null,
        visited: false,
        enableEmailMarketing: false,
        enableSmsMarketing: false,
        enablePrefCentreUnder16Warning: false,
        includePhoneField: true,
        noPreferenceNotice: true
    };

    alwaysShowAgeToggle = false;

    UNSAFE_componentWillReceiveProps (newProps) {
        if (newProps.smartcard !== this.props.smartcard) {
            if (!newProps.smartcard.withSmartcard() && this.props.smartcard.withSmartcard()) {
                const { onChange, form } = this.props;
                const updatedPreferences = form.get('preferences').set('autoDelayRepay', false);
                onChange('preferences', updatedPreferences);
            }
        }
    }

    _handleToggleAge = () => {
        this.alwaysShowAgeToggle = true;

        const { onAgeToggle, form } = this.props;
        const isOver16 = form.get('isOver16');
        let preferences = form.get('preferences');
        if (isOver16) {
            preferences = preferences.resetAllDisabledMarketingFields();
        }
        onAgeToggle(!isOver16, preferences);
    };

    render () {
        const {
            enableEmailMarketing,
            enableSmsMarketing,
            form,
            smartcard,
            onChange,
            visited,
            includePhoneField,
            enablePrefCentreUnder16Warning,
            noTandC,
            noOptDescription,
            noPreferenceNotice
        } = this.props;
        const isOver16 = form.get('isOver16');
        const showNoPreferences = !enableEmailMarketing && !enableSmsMarketing;
        const showAgeToggle = (smartcard && !smartcard.withSmartcard() && !smartcard.isValidDateOfBirth()) || !smartcard;

        return (
            <Col md={ 12 } className="signup-options form--vertical">
                {(showAgeToggle || this.alwaysShowAgeToggle) && (
                    <AgeCheckbox isOver16={isOver16} onToggle={this._handleToggleAge} />
                )}

                { !noOptDescription &&
                    <p className="margin-top--sm margin-bottom--sm">{ t('account.register.opt.description') }</p>
                }

                { enablePrefCentreUnder16Warning && !isOver16 &&
                    <FormError message={ t('preference-centre.age-restriction.warning') } /> }

                { !showNoPreferences &&
                    <PrefsTable
                        form={ form.get('preferences') }
                        onChange={ onChange }
                        isOver16={ isOver16 }
                        enableEmailMarketing={ enableEmailMarketing }
                        enableSmsMarketing={ enableSmsMarketing }
                        hideAutoDrOption
                    /> }

                { !showNoPreferences && form.preferences.isSomeSmsPrefSetToTrue() && includePhoneField &&
                    <PhoneNumber
                        form={ form }
                        onChange={ onChange }
                        visited={ visited }
                        required
                    /> }

                {!noPreferenceNotice && (
                    <p className='text-size--normal'>
                        <FormattedHTMLMessage message="preference-centre.edit-notice.short" />
                    </p>
                )}

                {!noTandC && (
                    <p>
                        <FormattedHTMLMessage
                            message="preference-centre.edit-notice"
                            privacyPolicy={ <PrivacyPolicyLink /> }
                        />
                    </p>
                )}

                {!noTandC && <SignupTAndCs form={ form } visited={ visited } onToggle={ onChange } />}
            </Col>
        );
    }
}

export default connectToStores([ FeatureFlagStore ], _getStateFromStores)(CustomerSignupOptions);



// WEBPACK FOOTER //
// ./src/components/customer/SignupOptions.js